import { render, staticRenderFns } from "./WechatLogin.vue?vue&type=template&id=188885bd&"
import script from "./WechatLogin.vue?vue&type=script&lang=js&"
export * from "./WechatLogin.vue?vue&type=script&lang=js&"
import style0 from "./WechatLogin.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports